import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import FontAwesome from 'react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCheck, faUserTimes } from '@fortawesome/free-solid-svg-icons'
import './TableGrid.css';
import {Button } from "reactstrap";
import {active, labels} from "../../util/constants";
import Car from "../../modules/Models/Car";
import renderIf from "render-if";

let propsG = [];

const cellEditProp = {
    mode: 'click'
};

const getIcons = (cell,row)=>{
    if(cell == 0){//active
        return  (<div title={labels.active} className={'icon-user-active'}><FontAwesomeIcon icon={faUserCheck} /></div>);
    }else{
        return  (<div title={labels.inactive} className={'icon-user-inactive'}><FontAwesomeIcon icon={faUserTimes} /></div>);
    }
};

const getButton = (cell,row)=>{
    return (
        <div>
            <Button title={labels.editUser} color="link" className={'btn-edit'} onClick={()=>{propsG.redirectToUserControl(row)}}><FontAwesome name={'edit'}/></Button>
            { renderIf(row.user_inactive == active)
            (
                <Button title={labels.removeUser} color="link" className={'btn-cancel'} onClick={()=>{propsG.disableUser(row.id_user)}}><FontAwesome name={'times-circle'}/></Button>
            )}
        </div>);
};

const formatVehicle = (cell, row)=>{
    if(row.carList && row.carList.length > 0){
        return(
                <div className='grid-vehicle'>
                    {
                        row.carList.map((car)=>{
                            car = new Car(car);
                            return (
                                <div >{car.getLicensePlate()} - {car.getModelCar()}</div>
                            )
                        })
                    }
                </div>
        );
    }
};

const TableGrid = (props) => {
    propsG = props;
    return(
        <div className="div-margin-top col-15">
                <BootstrapTable width data={props.data} options={props.options} cellEdit={ cellEditProp }  multiColumnSort={2} striped hover
                                condensed pagination >
                    <TableHeaderColumn dataField="id_user"  editable={false} isKey
                                       dataAlign='center' dataSort> {labels.registration} </TableHeaderColumn>
                    <TableHeaderColumn width='20%' dataField="user_name" dataAlign='center' editable={false}
                                       dataSort> {labels.name} </TableHeaderColumn>
                    <TableHeaderColumn dataField="profile_type"  dataAlign='center' editable={false}
                                       > {labels.profile} </TableHeaderColumn>
                    <TableHeaderColumn dataField="market"  dataAlign='center' editable={false}
                                        > {labels.market} </TableHeaderColumn>
                    <TableHeaderColumn  width='25%' dataField="license_plate"  dataAlign='center' editable={false}  dataFormat={formatVehicle}
                                       > {labels.vehicle} </TableHeaderColumn>
                    <TableHeaderColumn  dataField="actions"  editable={false} dataFormat={getButton}
                                        dataAlign='center'> {labels.action} </TableHeaderColumn>
                </BootstrapTable>
        </div>

    );
}

export default TableGrid;


// WEBPACK FOOTER //
// ./src/components/TableGrid/TableGrid.js